const STREET_SUFFIXES = [
  'st', 'street', 'ave', 'avenue', 'blvd', 'boulevard', 'rd', 'road', 'dr', 'drive',
  'ln', 'lane', 'way', 'hwy', 'highway', 'pkwy', 'parkway', 'ct', 'court', 'pl', 'place',
  'cir', 'circle', 'ter', 'terrace', 'trl', 'trail', 'loop', 'sq', 'square', 'ste', 'suite',
  'unit', 'apt', 'fl', 'floor', 'bldg', 'building', 'pike', 'run', 'row', 'pass', 'plaza',
  'expy', 'crossing', 'commons'
];

// Splits "234 North Federal Hwy #3115 Boca Raton, FL 33431" into
// ["234 North Federal Hwy #3115", "Boca Raton, FL 33431"]
export const splitAddressLines = (address) => {
  if (!address || typeof address !== 'string') return [address];
  const trimmed = address.trim();

  const tail = trimmed.match(/^(.*?)[,\s]+([A-Za-z]{2})\.?[\s,]+(\d{5}(?:-\d{4})?)$/);
  if (!tail) return [trimmed];

  const stateZip = `${tail[2].toUpperCase()} ${tail[3]}`;
  const head = tail[1].trim().replace(/,$/, '');

  const lastComma = head.lastIndexOf(',');
  if (lastComma > 0) {
    const street = head.slice(0, lastComma).trim();
    const city = head.slice(lastComma + 1).trim();
    if (street && city) return [street, `${city}, ${stateZip}`];
  }

  const words = head.split(/\s+/);
  let breakAt = -1;
  words.forEach((word, index) => {
    const bare = word.replace(/[.,#]/g, '').toLowerCase();
    if (/\d/.test(word) || STREET_SUFFIXES.includes(bare)) breakAt = index;
  });

  if (breakAt >= 0 && breakAt < words.length - 1) {
    return [
      words.slice(0, breakAt + 1).join(' '),
      `${words.slice(breakAt + 1).join(' ')}, ${stateZip}`
    ];
  }

  return [trimmed];
};
